import {Outlet} from '@tanstack/react-router'
import {createFileRoute} from '@tanstack/react-router'

export const Route = createFileRoute('/_app/projects/$projectId')({
    component: ProjectIdLayout,
})

function ProjectIdLayout() {
    return <Outlet />
}
